import FilterFactory from '@/lib/filterFactory';

const enum FilterKey {
    Patient = 'patientId',
    Active = 'isActive',
}

export default class LoyaltyCardsFilter {
    filterHandlers = {
        update: 'loyaltyCardsFilter/updateFilter',
        reset: 'loyaltyCardsFilter/resetFilter',
        resetState: 'loyaltyCardsFilter/resetFilterState',
        removeSelected: 'loyaltyCardsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        // filter value is set dynamically later
        filter.createHiddenEntity(FilterKey.Patient);
        filter.setName(FilterKey.Patient, 'search_patient');
        filter.setAction(FilterKey.Patient, 'loyaltyCardsFilter/updateSearch');

        filter.createRadioEntity(FilterKey.Active);
        filter.setTitle(FilterKey.Active, 'Карта активна');
        filter.setName(FilterKey.Active, 'radio_is_active');
        filter.setIconClassName(FilterKey.Active, 'icon-check-line');
        filter.setPreviewName(FilterKey.Active, 'Актив');
        filter.setRadioList(FilterKey.Active, [
            { id: 0, name: 'Активна', checked: false },
            { id: 1, name: '', checked: false },
            { id: 2, name: 'Не активна', checked: false },
        ]);
        filter.setAction(FilterKey.Active, 'loyaltyCardsFilter/updateRadio');
        filter.setClassName(FilterKey.Active, 'col-1-row-3');

        this.filterModel = filter.filterModel;
    }
}
